import { useModal } from '@/storybook/modal/useModal';
import { useVfm } from 'vue-final-modal';
import AddToCollectionModal from '@/components/modals/collections/Collections.vue';

export const useAddToCollectionModal = (itemId: string) => {
  const vfm = useVfm();

  const open = () => {
    vfm.closeAll();
    const { open } = useModal(AddToCollectionModal, { modalProps: { itemId } });

    return open();
  };

  return { open };
};
